<template>
  <div class="videos">
    <div v-if="videoList && videoList.length > 0" class="video-list">
      <videoItem @click.native="handle2Preview(item)" :video="item" v-for="(item, index) in videoList" :key="index" />
    </div>
    <div class="video-chat">
      <van-swipe-cell disabled v-for="(barrage, index) in barrageList" :key="index">
        <div class="video-chat-item">
          <div class="chat-time">{{ formatAttrTime(barrage.eventAttrTime) }}</div>
          <div class="chat-user van-ellipsis">{{ barrage.userName }}</div>
          <!-- <div class="chat-content">{{ barrage.barrageSendInfo }}</div> -->
          <div class="chat-content" v-html="deel(barrage.barrageSendInfo)"></div>
        </div>
        <template #right>
          <van-button square type="danger" text="删除" />
          <van-button square type="primary" text="收藏" />
        </template>
      </van-swipe-cell>

      <div v-if="barrageList.length === 0" class="no-data">
        <img src="@/assets/image/no_data.svg" alt="" />
        <div class="value">快来发送第一条视频弹幕</div>
      </div>
    </div>
    <videoBtn @on-send="handleSend" />
  </div>
</template>

<script>
import {getAllEventBarrageInfo, saveBarrageInfo} from '@/api'
import _ from 'lodash'
export default {
  props: ['videoBullet', 'isWenxuan'],
  components: {
    videoItem: () => import('./videoItem.vue'),
    videoBtn: () => import('./videoBtn.vue')
  },
  data() {
    return {
      id: this.$route.params.id,
      barrageList: []
    }
  },
  mounted() {
    if (this.videoDanmuSet.attrId) {
      this.getBarrageList(this.videoDanmuSet.attrId)
    }
    // 取消只有一个视频, 默认播放功能
    // if (this.videoList && this.videoList.length === 1 && !this.videoDanmuSet.attrId) {
    //   this.handle2Preview(this.videoList[0])
    // }
  },
  computed: {
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    videoList() {
      return this.activeInfo && this.activeInfo.videoList
    },
    videoDanmuSet() {
      return this.$store.state.activePlay.videoDanmuSet
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    async getBarrageList(eventAttrId) {
      const params = {
        eventAttrId: eventAttrId,
        eventInfoId: this.id
      }
      const result = await getAllEventBarrageInfo(params)
      if (result.code === 0) {
        this.barrageList = result.data
      }
    },
    deel(val) {
      return val.replace(/{emoji:(\d+)}/gi, function (index) {
        // eslint-disable-next-line no-unused-vars
        const [num] = index.match(/\d+/g)
        const img = require(`@/assets/image/emoji/${num}.png`)
        // eslint-disable-next-line no-undef
        return `<img style="width:18px;height:18px;vertical-align: middle;" src=${img}>`
      })
    },
    formatAttrTime(time) {
      time = parseInt(time)
      let m = time / 60
      let s = time % 60
      m = parseInt(m) < 10 ? '0' + parseInt(m) : parseInt(m)
      s = s < 10 ? '0' + s : s
      return m + ':' + s
    },
    async handle2Preview({eventAttrSmallPath, eventAttrPath, eventAttrId, eventAttrType}) {
      console.log('eventAttrPath', eventAttrPath, eventAttrSmallPath)
      const params = {
        eventAttrId,
        eventInfoId: this.id
      }
      const result = await getAllEventBarrageInfo(params)
      if (result.code === 0) {
        this.barrageList = result.data
      }
      this.$store.commit('setVideoDanmuSet', {attrId: eventAttrId})
      // eventAttrPath = this.$isCdn(eventAttrPath)
      if (eventAttrSmallPath) {
        eventAttrPath = (this.isWenxuan === 1 ? this.wenxuanSmallVideoCdn : this.smallVideoCdn) + eventAttrSmallPath
      } else {
        if (this.isWenxuan === 1) {
          eventAttrPath = this.wenxuanVideoCdn + eventAttrPath
        } else {
          eventAttrPath = this.$isCdn(eventAttrPath)
        }
      }
      console.log('eventAttrPath', eventAttrPath)
      this.$emit('on-previewVideo', {
        eventAttrPath,
        eventAttrId,
        eventAttrType,
        barrageList: _.cloneDeep(this.barrageList)
      })
    },
    handleSend(barrageSendInfo) {
      if (!this.videoDanmuSet.attrId) {
        return this.$Toast.fail('请先选择视频')
      }
      const videoElement = document.getElementById('videoElement')

      const data = {
        barrageSendColor: '#fff',
        barrageSendInfo,
        eventAttrId: this.videoDanmuSet.attrId,
        eventInfoId: this.id,
        eventAttrTime: videoElement.currentTime
      }
      saveBarrageInfo(data).then(res => {
        if (res.code === 0) {
          this.getBarrageList(this.videoDanmuSet.attrId)
          this.pushDanmu(barrageSendInfo)
        }
      })
    },
    pushDanmu(barrageSendInfo) {
      if (!this.videoBullet) return
      if (!this.videoDanmuSet.isOpen) return
      const talkInfo = barrageSendInfo.replace(/{emoji:(\d+)}/gi, function (index) {
        // eslint-disable-next-line no-unused-vars
        const [num] = index.match(/\d+/g)
        const img = require(`@/assets/image/emoji/${num}.png`)
        // eslint-disable-next-line no-undef
        return `<img style="width:18px;height:18px;vertical-align: middle;" src=${img}>`
      })
      if (this.userInfo.userFace) {
        this.videoBullet.push(`
          <div class="bullet-item">
            <img src="${this.$isCdn(this.userInfo.userFace)}">
            <span style="color:#fff">${this.userInfo.name}:</span>
            <span style="color:#fff">${talkInfo}</span>
          </div>`)
      } else {
        this.videoBullet.push(`
          <div class="bullet-item">
            <img src="${require('@/assets/image/user.png')}">
            <span style="color:#fff">${this.userInfo.name}:</span>
            <span style="color:#fff">${talkInfo}</span>
          </div>`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.videos {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.video-list {
  background: #fff;
  padding: 16px;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.video-chat {
  overflow-y: auto;
  flex: 1;
  height: 0;
  background: #f8f9fb;
  .video-chat-item {
    /* height: 40px; */
    margin-top: 10px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    .chat-time {
      color: #606266;
    }
    .chat-user {
      margin: 0 20px;
      max-width: 96px;
      color: #909399;
    }
    .chat-content {
      flex: 1;
      width: 0;
      color: #303133;
      word-wrap: break-word;
    }
  }
}

.no-data {
  text-align: center;
  img {
    margin-top: 40px;
    width: 80px;
  }
  .value {
    color: #c0c4cc;
  }
}
</style>
